var MonitorModule;
(function (MonitorModule) {
    MonitorModule["storage"] = "storage";
    MonitorModule["collection"] = "collection";
    MonitorModule["query"] = "query";
    MonitorModule["migration"] = "migration";
    MonitorModule["engine"] = "engine";
})(MonitorModule || (MonitorModule = {}));
export var EngineAction;
(function (EngineAction) {
    EngineAction["tableGetAll"] = "table#getAll";
    EngineAction["tableGetAllKeys"] = "table#getAllKeys";
    EngineAction["tableGet"] = "table#get";
    EngineAction["tableInsert"] = "table#insert";
    EngineAction["tableUpsert"] = "table#upsert";
    EngineAction["tableDelete"] = "table#delete";
    EngineAction["tableClear"] = "table#clear";
    EngineAction["tableBulkUpsert"] = "table#bulkUpsert";
    EngineAction["tableBulkDelete"] = "table#bulkDelete";
    EngineAction["tableQuery"] = "table#query";
    EngineAction["tableCreateIndex"] = "table#createIndex";
    EngineAction["tableDeleteIndex"] = "table#deleteIndex";
    EngineAction["indexGet"] = "index#get";
    EngineAction["indexGetAll"] = "index#getAll";
    EngineAction["indexGetAllKeys"] = "index#getAllKeys";
    EngineAction["cursorNext"] = "cursor#next";
    EngineAction["cursorValue"] = "cursor#value";
    EngineAction["cursorUpdate"] = "cursor#update";
    EngineAction["cursorDelete"] = "cursor#delete";
    EngineAction["transactionCommit"] = "transaction#commit";
    EngineAction["transactionRollback"] = "transaction#rollback";
    EngineAction["databaseClose"] = "database#close";
    EngineAction["databaseCreateTable"] = "database#createTable";
    EngineAction["databaseDeleteTable"] = "database#deleteTable";
    EngineAction["engineOpenDB"] = "engine#openDB";
    EngineAction["engineDeleteDB"] = "engine#deleteDB";
})(EngineAction || (EngineAction = {}));
/**
 * Represent the status code of monitored action.
 * If the status code is 0, the action is successful,
 * and any code greater than 0 means failure.
 */
var MonitorActionStatus;
(function (MonitorActionStatus) {
    MonitorActionStatus[MonitorActionStatus["success"] = 0] = "success";
    MonitorActionStatus[MonitorActionStatus["fail"] = 1] = "fail";
})(MonitorActionStatus || (MonitorActionStatus = {}));
var EngineMonitorEvent = /** @class */ (function () {
    function EngineMonitorEvent(action, cost) {
        this.module = MonitorModule.engine;
        /**
         * @deprecated use status instead
         */
        this.actionExecuteState = 0 /* success */;
        this.status = 0 /* success */;
        this.time = new Date();
        this.action = action;
        this.cost = cost;
    }
    EngineMonitorEvent.prototype.markError = function (error) {
        this.errorMsg = error.message;
        this.actionExecuteState = 1 /* fail */;
        this.status = 1 /* fail */;
    };
    return EngineMonitorEvent;
}());
export { EngineMonitorEvent };
var CollectionMonitorEvent = /** @class */ (function () {
    function CollectionMonitorEvent(action, cost) {
        this.module = MonitorModule.collection;
        this.status = 0 /* success */;
        /**
         * @deprecated please use event.status instead
         */
        this.actionExecuteState = 0 /* success */;
        this.write = { count: 0 };
        this.read = { count: 0 };
        this.delete = { count: 0 };
        this.fail = { count: 0, reasons: [] };
        this.time = new Date();
        this.action = action;
        this.cost = cost;
    }
    CollectionMonitorEvent.prototype.increment = function (type, count) {
        if (count === void 0) { count = 1; }
        this[type].count += count;
    };
    CollectionMonitorEvent.prototype.error = function (error) {
        this.actionExecuteState = 1 /* fail */;
        this.status = 1 /* fail */;
        this.increment('fail');
        this.fail.reasons.push(error.name);
    };
    return CollectionMonitorEvent;
}());
export { CollectionMonitorEvent };
//# sourceMappingURL=monitor-event.js.map